import {useConfigContext} from "@/ConfigProvider";
import {useAutocomplete} from "@/autocomplete/context/GlobalContext";

export function ShowAllButton() {
    const {autocompleteState, totalHits} = useAutocomplete();
    const {tc, algoliaConfig: {customizedUrl}} = useConfigContext();
    const {collections, query} = autocompleteState;
    const productCollections = collections.filter(({source}) => source.sourceId === "products");
    const items = productCollections[0]?.items || [];
    if (query || items.length > 0) {
        return (
            <div className={"algoliaAutocompleteShowAllButton marginTop--middle"}>
                <a
                    href={`/${customizedUrl}/search/?input_search=${encodeURIComponent(query)}`}
                    className="button button--primary"
                >
                    {tc.all} {totalHits} {tc.showHits}
                </a>
            </div>)
    }else{
        return <></>
    }
}